import { ReplaySubject } from 'rxjs';

type ValuesOf<T> = T[keyof T];

export type ABTestTaskListType = keyof typeof abTestList;
export type HeaderMainGroupType = ValuesOf<{
  [K in keyof typeof abTestList]: typeof abTestList[K]['headerMainGroup'];
}>;
export type ABVariantsType = ValuesOf<{
  [K in keyof typeof abTestList]: ValuesOf<typeof abTestList[K]['abTestGroupIds']>;
}>;

export interface ABTestItem<K extends keyof typeof abTestList> {
  nameOfTask?: ABTestTaskListType;
  alias?: string;
  headerMainGroup: HeaderMainGroupType;
  abTestVariants: ABVariantsType[];
  abTestGroupIds: Record<keyof typeof abTestList[K]['abTestGroupIds'], ABVariantsType>;
  resolvedValue?: ABVariantsType;
  resolvedValue$?: ReplaySubject<ABVariantsType>;
  resolvedCookieValue?: ABVariantsType;
  syncOnAuth?: boolean;
  debug?: boolean;
}

export const AB_TEST_LIST: {
  [K in keyof typeof abTestList]: ABTestItem<K>;
} = {} as any;

export const abTestList = {
  'DEVSS6810': {
    alias: 'DEVSS6810',
    headerMainGroup: 'ID1005',
    abTestGroupIds: {
      V1: 'ID1005',
      V2: 'ID1006',
    },
    syncOnAuth: true,
    debug: false,
  },
  'DEVSS6741': {
    alias: 'DEVSS6741',
    headerMainGroup: 'ID998',
    abTestGroupIds: {
      V1: 'ID998',
      V2: 'ID999',
    },
    syncOnAuth: true,
    debug: false,
  },
  'DEVSS7026': {
    alias: 'DEVSS7026',
    headerMainGroup: 'ID1107',
    abTestGroupIds: {
      V1: 'ID1107',
      V2: 'ID1108',
    },
    syncOnAuth: true,
    debug: false,
  },
} as const;
